import styled, { keyframes } from "styled-components";
import { ScanCow, ScanLoad } from "../../assets/images";
import { useState } from "react";
import { CloseWhite } from "../../assets/icons";

const LoaderModal = ({ message }) => {
  return (
    <StyledLoaderModal>
      <div>
        <img src={ScanLoad} />
        <span>{message || "Loading"}</span>
      </div>
    </StyledLoaderModal>
  );
};

const StyledLoaderModal = styled.div`
  z-index: 9999;
  height: 100vh;
  max-height: 100vh;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  > div {
    overflow: scroll;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 9;
    flex-direction: column;
    > span {
      color: #fec25e;
    }
    > img {
      width: 5rem;
      animation: ${keyframes`
    0% {
    transform: rotate(0deg);
    }
    100% {
    transform:rotate(360deg);
    }
    `} 1s linear infinite;
    }
  }
`;

export default LoaderModal;
